import { queryKeys } from "../queryKeys";
import {
  type CryptoFeeStructure,
  getCryptoFeeStructure,
} from "../rest/billing";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetCryptoFeeStructure = ({
  options,
}: {
  options?: QueryOptions<CryptoFeeStructure>;
} = {}) => {
  const { data } = useRequest(
    queryKeys.crypto.feeStructure(),
    () => getCryptoFeeStructure(),
    {
      ...options,
    },
  );

  return { ...data };
};

export default useGetCryptoFeeStructure;
